export default {
  label: {
    jobDetail: '职位详情页',
    mobile: '手机端',
    pc: '电脑端',
    weChatShareTipMessage: '您可以在这里设置分享到微信朋友和朋友圈的图标及文字。微信分享图标不能小于300px x 300px； 当微信分享的标题或内容中包含这三个占位符：#JOB_TITLE#， #JOB_LOCATION#， #COMPANY_NAME# 时，分享内容会自动替换这些属性。',
    pageSettingTitleKey: '职位描述个性化',
    jobDescriptionTipKey: '你的职位描述',
    fieldManagement: '字段管理'
  }
}
